import { useEffect, useState } from "react";
import { getCustomerDetail } from "api";
import Sparkline from "./Sparkline";

function friendlyLastDate(dateStr) {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  const now = new Date();
  const diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return "today";
  if (diffDays === 1) return "yesterday";
  if (diffDays === -1) return "tomorrow";
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
    timeZone: "America/Chicago",
  });
}

function formatPhone(raw) {
  if (!raw) return raw;
  const digits = raw.replace(/\D/g, "");
  if (digits.length === 11 && digits[0] === "1") {
    const [, area, prefix, line] = digits.match(/^1(\d{3})(\d{3})(\d{4})$/);
    return `+1 (${area}) ${prefix}-${line}`;
  }
  if (digits.length === 10) {
    const [, area, prefix, line] = digits.match(/^(\d{3})(\d{3})(\d{4})$/);
    return `(${area}) ${prefix}-${line}`;
  }
  return raw;
}

function getInitials(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function StatBadge({ label, count, color }) {
  return (
    <div className="cm-stat">
      <span className="cm-stat-count" style={{ color }}>{count}</span>
      <span className="cm-stat-label">{label}</span>
    </div>
  );
}

function CustomerModal({ phone, name, onClose }) {
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    getCustomerDetail(phone).then(setDetail);
  }, [phone]);

  const displayName = detail?.name || name;

  return (
    <div className="popup-wrapper" onClick={onClose}>
      <div className="popup cm-modal" onClick={(e) => e.stopPropagation()}>

        {/* Left — identity */}
        <div className="cm-left">
          <div className="cm-avatar">{getInitials(displayName)}</div>
          <div className="cm-name">{displayName}</div>
          <div className="cm-phone">{formatPhone(phone)}</div>
        </div>

        {/* Right — stats */}
        <div className="cm-right">
          <button className="gc-modal-close cm-close" onClick={onClose}>✕</button>

          {detail ? (
            <>
              <div className="cm-stats">
                <StatBadge label="Completed" count={detail.stats.completed} color="var(--ad-gold)" />
                <StatBadge label="Upcoming" count={detail.stats.upcoming + detail.stats.confirmed} color="var(--ad-text)" />
                <StatBadge label="Cancelled" count={detail.stats.cancel} color="#c64949" />
                <StatBadge label="No Show" count={detail.stats.noshow} color="#a09c9c" />
              </div>

              {detail.sparkline.length >= 2 && (
                <div className="cm-sparkline-wrapper">
                  <Sparkline data={detail.sparkline} />
                </div>
              )}

              {detail.lastReservation && (
                <div className="cm-last-res">
                  {new Date(detail.lastReservation) > new Date() ? "Upcoming reservation" : "Last reservation"}
                  <span className="cm-last-res-date">
                    {friendlyLastDate(detail.lastReservation)}
                  </span>
                </div>
              )}
            </>
          ) : (
            <div className="cm-skeleton">
              <div className="cm-skel-stats">
                {[0, 1, 2, 3].map((i) => <div key={i} className="cm-skel-stat" />)}
              </div>
              <div className="cm-skel-sparkline" />
              <div className="cm-skel-text" />
            </div>
          )}
        </div>

      </div>
    </div>
  );
}

export default CustomerModal;
